import { Sector } from '@/domain/impact/impact.entity';
import {
  AccommodationType,
  AccommodationTypeValues,
  Category,
  ImpactCo2Answer,
  ValuesAccommodation,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'ACCOMMODATION';
const SECTORS: Sector[] = ['TEAM', 'ARTISTS', 'PUBLIC'];

export function mapToAccommodationAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesAccommodation>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const accommodationType = mapToAccommodationType(row);
  const numberOfNights = mapToNumberOfNights(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      accommodationType,
      numberOfNights,
    },
  };
  return answer;
}

function mapToAccommodationType(row: ImportedRow): AccommodationType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<AccommodationType>(
    tgsValue,
    AccommodationTypeValues,
  );
  if (!result) {
    throw new ImportMappingError('accommodationType', tgsValue, row);
  }
  return result;
}

function mapToNumberOfNights(row: ImportedRow): number {
  const tgsValue = row['Number of nights'];
  const result = parseInt(tgsValue, 10);
  if (isNaN(result)) {
    throw new ImportMappingError('numberOfNights', tgsValue, row);
  }
  return result;
}
